exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.container[data-v-177e70a4] {\n    /* margin-right: auto;\n    margin-left: auto; */\n    width: 100%;\n    /* margin: 0 auto; */\n}\n.panel2[data-v-177e70a4], .panel21[data-v-177e70a4] {\n    background: #fcfcfc;\n    border: solid 1px #dbdbdb;\n    /*margin-bottom: 5%;*/\n    padding-bottom: 25px;\n    padding-top: 10px;\n    padding-left: 20px;\n    padding-right: 20px;\n    float: left;\n    width: 100%;\n}\n*[data-v-177e70a4] {\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-177e70a4","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/bankAccounts/CMAddBankAccount.vue
// module id = 1106
// module chunks = 2